export default "__VITE_PUBLIC_ASSET__dc671b67__"